import { S3_IMAGES_URL } from 'src/components/pages/loyalty/ReferralPage/constants';

import { SecondaryPlanetType } from 'src/types';

export const planetsData: SecondaryPlanetType[] = [
  {
    src: `${S3_IMAGES_URL}planets/planet_2.webp`,
    size: 200,
    mobileSize: 90,
    delay: 0,
    direction: -1,
    speed: 4,
    id: 1,
  },
  {
    src: `${S3_IMAGES_URL}planets/planet_1.webp`,
    size: 400,
    mobileSize: 180,
    delay: 0,
    direction: -1,
    speed: 2,
    id: 3,
  },
  {
    src: `${S3_IMAGES_URL}planets/planet_5.webp`,
    size: 200,
    mobileSize: 142,
    delay: 0,
    direction: 1,
    speed: 2,
    id: 4,
  },
];

export const behindPlanet: SecondaryPlanetType = {
  src: `${S3_IMAGES_URL}planets/planet_4.webp`,
  size: 360,
  mobileSize: 180,
  delay: 0,
  direction: 1,
  speed: 4,
  id: 2,
};
